// keyvue-app hands its refresh token over in the URL: /authenticate?token=…&redirect=… and /document?token=….
// Take it out of the address bar at start-up, before the router, Sentry or a login redirect reads the URL, so it
// can't end up in Sentry, in keyvue-app's /user/login?redirect= or in a Referer header. main.ts imports this module
// before the app's other modules (the vendor chunks load first, but don't keep or send the URL); AuthenticateView
// reads the token from here. Only these two paths: another page's ?token= is left alone.
const params = new URLSearchParams(window.location.search);
// As vue-router matches them: under the app's base path, any case, with or without a trailing slash
const isHandover = ['authenticate', 'document']
    .map((path) => `${import.meta.env.BASE_URL}${path}`.toLowerCase())
    .includes(window.location.pathname.replace(/\/$/, '').toLowerCase());

const handoverToken = isHandover ? params.get('token') : null;

if (isHandover && params.has('token')) {
    params.delete('token');
    const query = params.toString();

    window.history.replaceState(
        window.history.state,
        '',
        `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`,
    );
}

export default handoverToken;
